import { useState } from "react";
import { mediaUrl } from "../lib/api";

// Lazy-loaded image with graceful fallback to a placeholder gradient.
export function MediaImage({ src, alt = "", className = "", fallback }) {
  const [errored, setErrored] = useState(false);
  const url = mediaUrl(src);
  if (!url || errored) {
    return (
      <div className={`bg-gradient-to-br from-slate-800 to-slate-900 flex items-center justify-center ${className}`}>
        {fallback || <span className="font-display text-emerald-500/40 text-3xl font-bold">S&amp;M</span>}
      </div>
    );
  }
  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => setErrored(true)}
      className={className}
    />
  );
}
